import branchService from "../../services/branch/BranchService.js";
import i18n from "../../i18n/index";

export default {
  data() {
    return {
      search: "",
      pagination: {},
      branches: [],
      headers: [
        {
          text: i18n.t('headers.name'),
          sortable: false,
          value: "name"
        },
        {
          text: i18n.t('headers.provider'),
          sortable: false,
          value: "providerId"
        },
        {
          text: i18n.t('headers.name'),
          sortable: false,
          value: "type"
        }
      ],
      rowsPerPageItems: [5, 10, 15, 20]
    };
  },
  props: { onRowClick: { type: Function, default: () => { } } },
  watch: {
    pagination: {
      handler() {
        this.getBranches();
      },
      deep: true
    }
  },
  mounted() {
    this.getBranches();
  },
  methods: {
    update(item){
      this.$emit('update', item)
    },
    getBranches() {
      const { page, rowsPerPage } = this.pagination;
      branchService.getBranch(page - 1, rowsPerPage, this.search).then(response => {
        this.branches = response.data[0];
      });
    }
  }
};
